//
// Model.
//
export var HttpMethod;
(function (HttpMethod) {
    HttpMethod["HEAD"] = "HEAD";
    HttpMethod["GET"] = "GET";
    HttpMethod["POST"] = "POST";
    HttpMethod["PUT"] = "PUT";
    HttpMethod["PATCH"] = "PATCH";
    HttpMethod["DELETE"] = "DELETE";
})(HttpMethod || (HttpMethod = {}));
